import { Location, matchPath } from 'react-router'

import { UserSessionTeam } from 'types/api/users/sessions/user-session'

/**
 * Constants
 */
export const MAIN_HEADER_MENU_WIDTH = 320

/**
 * Utility functions
 */
export function getTeamSwitchRedirectUrl(
  team: UserSessionTeam,
  location: Location
) {
  // Will remain on the team settings page if switching from that page.
  if (matchPath('/settings/team/*', location.pathname)) {
    return `/settings/team/${team.identifier}`
  }

  // reports pages need to remain on the end point they came from
  if (matchPath('/reports/*', location.pathname)) {
    return location.pathname
  }

  // redirect to root feature page if switching teams
  // /scenarios/detail/[id] => /scenarios
  // /attacks/detail/[id] => /attacks
  // etc
  return `/${location.pathname
    .split('/') // split on /
    .filter(Boolean) // remove leading empty strings
    .slice(0, 1) // take first item
    .join('')}` // coerce into string
}
